import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";

function ConfirmSignout({ open, handleCancel, handleConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="confirm-signout-dialog"
    >
      <DialogTitle id="confirm-signout-dialog">Log Out</DialogTitle>
      <DialogContent>{"Sei sicuro di voler uscire?"}</DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Annulla
        </Button>
        <Button onClick={handleConfirm} color="error">
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmSignout;
